import pubsub from 'pubsub-js';
import gaTracker from './ga-tracker';

const STATUS_INIT = 'init';
const STATUS_ENGAGED = 'engaged';
const STATUS_FINAL = 'final';
const STATUS_SALES = 'sales';

var elm_calc,
	elm_bill_input,
	elm_plan_selector,
	elm_plan_selector_btn,
	elm_amount_yr,
	elm_amount_mo,
	elm_amount_base,
	elm_next_btn,
	elm_cta_btn,
	calc_status = {},
	init_btn_copy,
	elm_alert,
	elm_result_sales;
// price table => data amount : plan cost for the 12 month version of it 
var calc_data = {
	'status' : STATUS_INIT,
	'bill' : 0,
	'plan' : 0,
	'price_table' : {
		'3' : 15,
		'8' : 20,
		'12': 25,
		'unlimited': 'unlimited'
	},
	'sales_copy': ''
}

// Entered bill amount
function getBill() {
	return calc_data.bill;
}

function setBill(amount) {
	calc_data.bill = amount;
}

// Selected data plan
function getPlan() {
	return calc_data.plan;
}

function setPlan(plan) {
	calc_data.plan = plan;
}

function getStatus() {
	return calc_data.status;
}

function setStatus(status) {
	calc_data.status = status;
}

function resetAlert() {
	elm_alert.innerText = '';
}

function setAlert(message) {
	elm_alert.innerText = message;
}

function setSalesCopy(message) {
	calc_data.sales_copy = message;
}

function getSalesCopy() {
	return calc_data.sales_copy;
}

function sanitization() {
	var message = '',
		billAmount = getBill(),
		dataPlan = getPlan();

	if(!billAmount || !dataPlan) {
		return false;
	}

	if (dataPlan === 'unlimited') {
		message = "Whatcha doin' with all that data? The average American only uses 5GB a month. You might be buying unlimited without really needing it!";
	} else if  (billAmount <= 15 && billAmount > 0) {
		message = "That's a crazy good deal—game respect game. But does it include unlimited talk & text and at least 3GB of 4G LTE? Huh? ‘Cuz Mint does!";
	} else if (dataPlan == 8 && billAmount <= 20 && billAmount > 15) {
		message = "That's a crazy good deal—game respect game. But does it include unlimited talk & text and 10GB of 4G LTE? Huh? ‘Cuz Mint does!";
	} else if (dataPlan == 12 && billAmount <= 25 && billAmount > 15) {
		message = "That's a crazy good deal—game respect game. But does it include unlimited talk & text and 12GB of 4G LTE? Huh? ‘Cuz Mint does!";
	} 

	return message;

}

function updateUiStatus() {
	// .Calc 			: Initial status.
	// .Calc--engaged	: Phone bill amount entered.
	// .Calc--final		: Desired data plan selected.
	// .Calc--sales		: User bill is lower than our price.

	var status = getStatus();

	switch (status) {
		case STATUS_ENGAGED:
			// Update status to '.Calc--engaged'.
			elm_calc.classList.remove('Calc--final');
			elm_calc.classList.remove('Calc--sales');
			elm_calc.classList.add('Calc--engaged');

			updateUi(STATUS_ENGAGED);

			break;

		case STATUS_FINAL:
			// Update status to '.Calc--final'.
			elm_calc.classList.remove('Calc--engaged');
			elm_calc.classList.remove('Calc--sales');
			elm_calc.classList.add('Calc--final');

			updateUi(STATUS_FINAL);

			break;

		case STATUS_SALES:
			// Update status to '.Calc--final'.
			elm_calc.classList.remove('Calc--engaged');
			elm_calc.classList.remove('Calc--final');
			elm_calc.classList.add('Calc--sales');

			updateUi(STATUS_SALES);

			break;

		default:
			// Reset status.
			elm_calc.classList.remove('Calc--engaged');
			elm_calc.classList.remove('Calc--final');

			updateUi(STATUS_INIT);

			break;
	}

}

function updateUi(status) {
	var calculated_num,
		sales_copy;

	switch (status) {

		case STATUS_ENGAGED:

			break;

		case STATUS_FINAL:
			calculated_num = getCalculation();

			elm_amount_yr.innerHTML = calculated_num.yearly_save;
			elm_amount_mo.innerHTML = calculated_num.monthly_save;
			elm_amount_base.innerHTML = calculated_num.base_amount;

			break;

		case STATUS_SALES:
			sales_copy = getSalesCopy();

			if(sales_copy) {
				elm_result_sales.innerHTML = sales_copy;
			}

			break;

		default:

			elm_plan_selector_btn.innerHTML = init_btn_copy;
			break;
	}

}

function getCalculation() {
	var plan = getPlan(),
		base_amount =  calc_data.price_table[plan], // selected data price
		monthly_save = getBill() - base_amount, // bill - base amount
		yearly_save = monthly_save * 12;
	
	return {
		'base_amount' : base_amount,
		'monthly_save' : monthly_save,
		'yearly_save' : yearly_save
	}
}

function handleBillInput(e) {
	e.preventDefault();

	var value = parseInt(e.target.value, 10),
		track_data = e.target.dataset.track,
		isNextBtnHidden = elm_next_btn.offsetParent === null,
		setStatusInit = function() {
			setBill(0);
			setStatus(STATUS_INIT);
			updateUiStatus();
		},
		moveOn = function() {
			setBill(value);
			setStatus(STATUS_ENGAGED);
			updateUiStatus();

			trackCalc(track_data + '|' + value);
		},
		isDataClean = function(data) {
			if( !data || isNaN(data) ) {
				setAlert('Please enter a proper monthly bill amount');

				return false;
			} else if (data <= 0) {
				setAlert('Please enter a positive number');

				return false;
			}

			return true;
		};

	resetAlert();

	if(isNextBtnHidden) {
		// Desktop
		if (!isDataClean(value)) {
			setStatusInit();
		} else {
			moveOn();
		}
		
	} else {
		// Mobile
		value = elm_bill_input.value;

		// Mobile requires 'next' button click to move on.
		if (e.target.nodeName === 'BUTTON') {
			// Since the data is clean at this point.
			moveOn();
		} else {
			if (!isDataClean(value)) {
				setStatusInit();

				elm_next_btn.disabled = true;
			} else {
				elm_next_btn.disabled = false;
			}
		}
	}

}

function handleDataSelection(e) {
	e.preventDefault();
	
	var value,
		track_data,
		sanitizedData;

	if (getStatus() === STATUS_INIT) {
		setAlert('Please enter a proper monthly bill amount first.');

		return;
	}

	resetAlert();

	if(e.target && e.target.nodeName == 'A') {
		value = e.target.dataset.value;

		track_data = e.target.dataset.track;

		elm_plan_selector_btn.innerHTML = e.target.innerText;

		track_data = track_data + '|' + e.target.innerText;

		setPlan(value);

		sanitizedData = sanitization();

		if (!sanitizedData) {
			setStatus(STATUS_FINAL);
		} else {
			setSalesCopy(sanitizedData);

			setStatus(STATUS_SALES);

			// console.log(sanitizedData);
		}

		updateUiStatus();

		trackCalc(track_data);

		// console.log(value);
	}
}

function trackCalc(value) {
	var data = value.split('|'),
		tracker = {};

	if (typeof window.ga == 'undefined') {
		return;
	}

	tracker['event'] = data[0];
	tracker['step description'] = data[1];
	tracker['calculator location'] = data[2];
	tracker['step value'] = data[3];

	if (getStatus() === STATUS_FINAL) {
		tracker['total savings'] = getCalculation().yearly_save;
	}

	// console.log('TRACKER: ', tracker);

	window.dataLayer.push(tracker);

}

function init() {
	if (!document.getElementById('js-calc')) {
		return;
	}

	// Cache DOM elements.
	elm_calc = document.getElementById('js-calc');
	elm_bill_input = elm_calc.querySelector('.js-calc-input');
	elm_plan_selector = elm_calc.querySelector('.js-dropdown');
	elm_plan_selector_btn = elm_plan_selector.querySelector('.dropdown-toggle');
	elm_amount_yr = elm_calc.querySelector('.js-calc-amount-yr');
	elm_amount_mo = elm_calc.querySelector('.js-calc-amount-mo');
	elm_amount_base = elm_calc.querySelector('.js-calc-amount-base');
	elm_next_btn = elm_calc.querySelector('.js-calc-btn-next');
	elm_cta_btn = elm_calc.querySelector('.js-calc-btn-cta');
	elm_alert = elm_calc.querySelector('.alert');
	elm_result_sales = elm_calc.querySelector('.js-result-sales');

	init_btn_copy = elm_plan_selector_btn.innerHTML;
	
	// DOM event bindings.
	elm_bill_input.addEventListener('blur', handleBillInput, false);
	// elm_bill_input.addEventListener('touchend', handleBillInput, false);

	elm_next_btn.addEventListener('click', handleBillInput, false);

	elm_plan_selector.addEventListener('click', handleDataSelection, false);

	elm_cta_btn.addEventListener('click', function(e) {
		// e.preventDefault();

		var track_data = e.target.dataset.track;

		track_data = track_data + '|' + e.target.getAttribute('href');

		trackCalc(track_data);
	}, false);

}

export default init;